import {
    collection,
    onSnapshot,
    type SnapshotListenOptions,
} from 'firebase/firestore';
import { sharedConfig } from '../base-config';
import { itemService } from '../services';
import { firestore } from './firestore';
import { type StockAdjustmentEvent, type StockEventTrackerData } from './types';

export class FirestoreStockEventTracker {
    subscribe(branchId: string) {
        const trackerKey = sharedConfig.STOCK_EVENT_TRACKER_KEY;
        const collectionUrl = `${trackerKey}/${branchId}/variants`;

        const options: SnapshotListenOptions = { includeMetadataChanges: true };

        return onSnapshot(
            collection(firestore, collectionUrl),
            options,
            async (snapshot) => {
                if (snapshot.metadata.fromCache) {
                    return;
                }

                const changes = snapshot.docChanges(options);

                for (const change of changes) {
                    const variantId = change.doc.id;
                    const remoteData =
                        change.doc.data() as StockEventTrackerData;

                    const availableQuantity = Number(
                        remoteData.availableQuantity,
                    );

                    const stockAdjustmentEvent: StockAdjustmentEvent = {
                        updatedAt: remoteData.adjustmentTime,
                        items: {
                            [variantId]: {
                                availableQuantity,
                                itemId: '',
                                status: remoteData.status,
                            },
                        },
                    };

                    await itemService.updateVariantStock(stockAdjustmentEvent);
                }
            },
        );
    }
}

const firestoreStockEventTracker = new FirestoreStockEventTracker();
export { firestoreStockEventTracker };
